import React, {Component} from 'react'
import PropTypes from 'prop-types'
import RowBoxItem from "./RowBoxItem"

class ListNextItemsTable extends Component {
    render() {
        const {items, fetchListBoxesItems} = this.props

        return (
            <tbody className="ListNextItemsTable">
            {items.map((item, index) => {
                return (
                    <RowBoxItem index={index} key={item._id} item={item} fetchListBoxesItems={fetchListBoxesItems}/>
                )
            })}
            </tbody>
        )
    }
}

ListNextItemsTable.propTypes = {
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    fetchListBoxesItems: PropTypes.func.isRequired
}

export default ListNextItemsTable
